// Volatility estimation from comparables — PSD §6.2, F3.4. Engine layer (framework-free).
/**
 * Estimate volatility from a peer set of >= 3 public comparables.
 * Computes asset/equity and unlevered/relevered volatilities.
 */
export function estimateVolatility(comparables, leverage) {
    if (comparables.length < 3) {
        return {
            assetVolatility: 0.5,
            equityVolatility: 0.5,
            unleveredVolatility: 0.5,
            releveredVolatility: 0.5,
            mean: 0.5,
        };
    }
    // Per-comparable annualized volatility from periodic returns.
    const annualization = Math.sqrt(12); // assume monthly returns
    const vols = comparables.map((c) => std(c.returns) * annualization);
    const mean = vols.reduce((s, v) => s + v, 0) / vols.length;
    const equityVolatility = mean;
    const assetVolatility = leverage
        ? equityVolatility / (1 + leverage.debtToEquity)
        : equityVolatility;
    const unleveredVolatility = leverage
        ? equityVolatility / (1 + (1 - 0.21) * leverage.debtToEquity)
        : equityVolatility;
    const releveredVolatility = leverage
        ? unleveredVolatility * (1 + (1 - 0.21) * leverage.debtToEquity)
        : equityVolatility;
    return { assetVolatility, equityVolatility, unleveredVolatility, releveredVolatility, mean };
}
function std(xs) {
    if (xs.length === 0)
        return 0;
    const mean = xs.reduce((s, x) => s + x, 0) / xs.length;
    const variance = xs.reduce((s, x) => s + (x - mean) ** 2, 0) / xs.length;
    return Math.sqrt(variance);
}
//# sourceMappingURL=volatility.js.map